import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';

// Layout Components
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import WhyWarehaus from "./pages/WhyWarehaus";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import IndustryDetail from "./pages/IndustryDetail";
import Contact from "./pages/Contact";
import GetQuote from "./pages/GetQuote";

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen">
      <Toaster 
        position="top-center" 
        richColors
        toastOptions={{
          style: {
            background: '#111111',
            border: '1px solid rgba(59, 130, 246, 0.3)',
            color: '#fff',
            fontSize: '14px',
            padding: '16px 24px',
          },
          className: 'font-body',
        }}
        expand={true}
      />
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-warehaus" element={<WhyWarehaus />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:productId" element={<ProductDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/industries/:industryId" element={<IndustryDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-quote" element={<GetQuote />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
